import { openNewChatComposer } from '@/lib/openHomeComposer';
import React, { useCallback } from 'react';
import { Platform } from 'react-native';
import { useRouter } from 'expo-router';
import { useChatStore, FILTER_CONFIGS } from '@/store';
import { useTranslation } from '@/hooks/useTranslation';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import DropdownMenuFilter from '@/components/DropdownMenu/DropdownMenuFilter';

const FilterDropdown = React.memo(({ chatFilter, chatSort, handleFilterSortClick }) => {
  const { t } = useTranslation();
  React.useEffect(() => {
    return () => {
      if (Platform.OS === 'web') {
        document.body.style.pointerEvents = '';
      }
    };
  }, []);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <NavigationBarButton
          icon="filter"
          title={t('nav.routes.library.filter')}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content 
        className="DropdownMenuContent"
        onCloseAutoFocus={() => {
          if (Platform.OS === 'web') {
            document.body.style.pointerEvents = '';
          }
        }}
      >
        <DropdownMenuFilter
          labels={[
            {
              id: 'filters',
              title: 'Filter',
              children: FILTER_CONFIGS.library.filters
            },
            {
              id: 'sort',
              title: 'Sort',
              children: FILTER_CONFIGS.library.sort
            }
          ]}
          currentLabelPath={[
            chatFilter && chatFilter !== 'all' ? FILTER_CONFIGS.library.filters.find(l => l.id === chatFilter) : null,
            chatSort ? FILTER_CONFIGS.library.sort.find(l => l.id === chatSort) : null
          ].filter(Boolean)}
          onLabelClick={(labelId) => {
            handleFilterSortClick(labelId);
            if (Platform.OS === 'web') {
              document.body.style.pointerEvents = '';
            }
          }}
        />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
});

FilterDropdown.displayName = 'FilterDropdown';

const LibraryRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const router = useRouter();
  const chatSort = useChatStore(state => state.filters.sort);
  const chatFilter = useChatStore(state => state.filters.type);
  const handleFilterSortClick = useChatStore(state => state.handleFilterSortClick);

  const handleNewChat = useCallback(() => {
    openNewChatComposer(router, { replace: true });
  }, [router]);

  return (
    <NavigationBarButtonContainer rightPadding>
      <FilterDropdown
        chatFilter={chatFilter}
        chatSort={chatSort}
        tooltip={t('nav.routes.library.filterChats')}
        handleFilterSortClick={handleFilterSortClick}
      />
      <NavigationBarButton
        icon="pen-to-square"
        title={t('nav.routes.library.newChat')}
        tooltip={t('nav.routes.library.newChatTooltip')}
        tooltipShortcut='⌘ ⇧ O'
        onPress={handleNewChat}
      />
    </NavigationBarButtonContainer>
  );
});

LibraryRouteNavigationHeaderRight.displayName = 'LibraryRouteNavigationHeaderRight';

const LibraryRouteNavigationOptions = {
  title: 'Library',
  headerTitle: 'Library',
  headerRight: () => <LibraryRouteNavigationHeaderRight />
};

export default LibraryRouteNavigationOptions; 